export default function Icon() {
  return (
    <svg
      width="112"
      height="81"
      viewBox="0 0 112 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1709 20.5314H0.990356V41.8947H34.8235L53.8309 32.692V7.54688L28.1709 20.5314Z"
        fill="#E4EBF8"
      />
      <path
        d="M70.5597 7.89041H57.1331V19.4698H70.0902L107.084 14.0053V0.734619L70.5597 7.89041Z"
        fill="#E4EBF8"
      />
      <path
        d="M73.5883 60.9141H60.0233V71.427H73.114L107.084 77.6622V67.1492L73.5883 60.9141Z"
        fill="#E4EBF8"
      />
      <path
        d="M83.3863 19.4697H58.3718V31.1082H85.2671L107.084 31.1082V19.4697L83.3863 19.4697Z"
        fill="#E4EBF8"
      />
      <path
        d="M84.4238 49.8433H59.1974V61.1979H86.3205L108.323 61.1979V49.8433L84.4238 49.8433Z"
        fill="#E4EBF8"
      />
      <path
        d="M33.4943 41.8948H5.53137V59.8769H33.4943L57.5462 71.7007V49.9278L33.4943 41.8948Z"
        fill="#E4EBF8"
      />
      <rect
        x="7.09656"
        y="19.0969"
        width="41.866"
        height="5.87593"
        rx="2.83866"
        transform="rotate(90 7.09656 19.0969)"
        fill="#6061E5"
      />
      <path
        d="M57.2295 47.7419C58.7972 47.7419 60.0681 49.0129 60.0681 50.5806L60.0681 72.0795C60.0681 73.6472 58.7972 74.9181 57.2295 74.9181L56.9427 74.9181C55.375 74.9181 54.104 73.6472 54.104 72.0795L54.104 50.5806C54.104 49.0129 55.375 47.7419 56.9427 47.7419L57.2295 47.7419Z"
        fill="#6061E5"
      />
      <rect
        x="60.0681"
        y="5.87598"
        width="27.1762"
        height="5.96407"
        rx="2.83866"
        transform="rotate(90 60.0681 5.87598)"
        fill="#6061E5"
      />
      <rect
        x="111.394"
        width="14.6898"
        height="5.87593"
        rx="2.83866"
        transform="rotate(90 111.394 0)"
        fill="#6061E5"
      />
      <rect
        x="111.483"
        y="18.3623"
        width="14.6898"
        height="5.96407"
        rx="2.83866"
        transform="rotate(90 111.483 18.3623)"
        fill="#6061E5"
      />
      <rect
        x="111.483"
        y="48.4766"
        width="14.6898"
        height="5.96407"
        rx="2.83866"
        transform="rotate(90 111.483 48.4766)"
        fill="#6061E5"
      />
      <rect
        x="111.483"
        y="65.3699"
        width="14.6898"
        height="5.96407"
        rx="2.83866"
        transform="rotate(90 111.483 65.3699)"
        fill="#6061E5"
      />
    </svg>
  );
}
